module.exports = __webpack_public_path__ + "img/tinto(nuevo).19fdf670.png";